{
  "auth": {
    "login": {
      "title": "تسجيل الدخول",
      "welcome_back": "مرحباً بعودتك",
      "subtitle": "قم بتسجيل الدخول إلى حسابك",
      "university_subtitle": "قم بتسجيل الدخول إلى حسابك الجامعي",
      "company_subtitle": "قم بتسجيل الدخول إلى حساب شركتك",
      "platform_subtitle": "قم بتسجيل الدخول إلى حساب مدير النظام",
      "select_role_label": "اختر دورك",
      "university": "جامعة",
      "company": "شركة",
      "other": "آخر",
      "username_placeholder": "اسم المستخدم أو البريد الإلكتروني",
      "password_placeholder": "كلمة المرور",
      "forgot_password": "نسيت كلمة المرور؟",
      "login_button": "تسجيل الدخول",
      "logging_in": "جاري تسجيل الدخول...",
      "signup_text": "ليس لديك حساب؟",
      "signup_link": "إنشاء حساب",
      "invalid_credentials": "اسم المستخدم أو كلمة المرور غير صحيحة",
      "loading": "جاري التحميل...",
      "form_title": "ادخل الساحة.",
      "hero_line1_prefix": "تدرّب مثل",
      "hero_line1_highlight": "المهاجمين",
      "hero_line2_prefix": "دافع مثل",
      "hero_line2_highlight": "المعماريين"
    },
    "shell": {
      "enterprise_tagline": "ساحة سيبرانية للمؤسسات",
      "footer": "© {{year}} Quantum Vanguard. جميع الأنظمة تعمل بشكل طبيعي."
    },
    "company_login": {
      "tagline": "بوابة المؤسسات",
      "hero_line1_prefix": "دافع عن",
      "hero_line1_highlight": "المؤسسة",
      "hero_line2_prefix": "درّب",
      "hero_line2_highlight": "القوى العاملة",
      "form_eyebrow": "تسجيل دخول المؤسسات",
      "form_title": "مرحباً بعودتك."
    },
    "platform_login": {
      "tagline": "إدارة المنصة",
      "hero_line1_prefix": "أدِر",
      "hero_line1_highlight": "الساحة",
      "hero_line2_prefix": "شكّل",
      "hero_line2_highlight": "المنصة",
      "form_eyebrow": "تسجيل دخول مشرف المنصة",
      "form_title": "لوحة المشغّل."
    },
    "university_login": {
      "tagline": "بوابة الجامعة",
      "hero_line1_prefix": "علّم مثل",
      "hero_line1_highlight": "الباحثين",
      "hero_line2_prefix": "تعلّم مثل",
      "hero_line2_highlight": "المشغّلين",
      "form_eyebrow": "تسجيل دخول الجامعة",
      "form_title": "مرحباً بعودتك."
    },
    "registration": {
      "tagline": "بوابة التسجيل",
      "student_form_eyebrow": "تسجيل الطالب",
      "professional_form_eyebrow": "تسجيل المحترف",
      "role_selection_form_eyebrow": "اختيار الحساب",
      "student_hero": {
        "prefix": "أنشئ",
        "highlight": "حسابك الشخصي",
        "suffix": ""
      },
      "professional_hero": {
        "prefix": "أنشئ",
        "highlight": "حسابك المهني",
        "suffix": ""
      },
      "role_selection_hero": {
        "line1_prefix": "اختر",
        "line1_highlight": "دورك",
        "line2_prefix": "ادخل",
        "line2_highlight": "الساحة"
      }
    },
    "forgot_password": {
      "title": "إعادة تعيين كلمة المرور",
      "description": "أدخل بريدك الإلكتروني وسنرسل رابط إعادة التعيين إذا كان الحساب موجودًا.",
      "email_placeholder": "أدخل البريد الإلكتروني",
      "send_button": "إرسال رابط إعادة التعيين",
      "sending": "جاري الإرسال...",
      "cancel": "العودة لتسجيل الدخول",
      "success_message": "تم إرسال رابط إعادة تعيين كلمة المرور إلى بريدك الإلكتروني.",
      "error_message": "فشل إرسال رابط إعادة التعيين. يرجى المحاولة مرة أخرى."
    },
    "api_messages": {
      "username_password_required": "اسم المستخدم وكلمة المرور مطلوبان",
      "invalid_token_response": "استجابة رمز غير صالحة من الخادم",
      "email_verification_required": "التحقق من البريد الإلكتروني مطلوب. يرجى التحقق من بريدك الإلكتروني والتحقق من حسابك قبل تسجيل الدخول.",
      "invalid_username_password": "اسم المستخدم أو كلمة المرور غير صحيحة",
      "refresh_token_required": "رمز التحديث مطلوب",
      "failed_refresh_token": "فشل تحديث الرمز",
      "logged_out_success": "تم تسجيل الخروج بنجاح",
      "logout_completed": "اكتمل تسجيل الخروج",
      "failed_user_info": "فشل استرداد معلومات المستخدم",
      "email_required": "البريد الإلكتروني مطلوب",
      "user_not_found": "المستخدم غير موجود",
      "current_new_password_required": "كلمة المرور الحالية وكلمة المرور الجديدة مطلوبتان",
      "password_updated_success": "تم تحديث كلمة المرور بنجاح",
      "failed_update_password": "فشل تحديث كلمة المرور",
      "employee_email_required": "البريد الإلكتروني للموظف مطلوب",
      "company_lookup_not_integrated": "البحث عن الشركة لم يتم دمجه بعد؛ لا تتوفر معلومات المطابقة.",
      "email_already_registered": "البريد الإلكتروني مسجل بالفعل",
      "email_already_verified": "تم التحقق من البريد الإلكتروني بالفعل. يرجى تسجيل الدخول.",
      "username_already_taken": "اسم المستخدم مأخوذ بالفعل",
      "invalid_role_self_registration": "دور غير صالح للتسجيل الذاتي. يُسمح فقط بـ 'طالب' أو 'مستخدم الشركة'",
      "registration_success": "التسجيل ناجح. يرجى التحقق من بريدك الإلكتروني قبل تسجيل الدخول.",
      "failed_register_user": "فشل تسجيل المستخدم",
      "permission_denied_promote": "تم رفض الإذن. يمكن فقط لمسؤولي النظام ترقية المستخدمين.",
      "student_role_cannot_change": "المستخدم لديه دور 'طالب'. لا يمكن تغيير دور الطالب إلى مستخدم الشركة أو مسؤول الشركة.",
      "user_not_company_user": "المستخدم ليس لديه دور 'مستخدم الشركة'. لا يمكن ترقية المستخدمين بدون هذا الدور.",
      "user_already_company_admin": "المستخدم لديه بالفعل دور 'مسؤول الشركة'. لا يمكن الترقية مرة أخرى.",
      "promoted_to_company_admin": "تمت ترقية المستخدم بنجاح إلى مسؤول الشركة",
      "failed_promote_user": "فشل ترقية المستخدم",
      "password_reset_sent": "إذا كان هناك حساب لهذا البريد الإلكتروني، فقد تم إرسال رابط إعادة تعيين كلمة المرور.",
      "rate_limit_exceeded": "محاولات تسجيل دخول كثيرة. يرجى الانتظار والمحاولة مرة أخرى."
    },
    "validation": {
      "string_too_short": "يجب أن يتكون {{field}} من {{min}} أحرف على الأقل",
      "string_too_long": "يجب ألا يتجاوز {{field}} {{max}} حرفًا",
      "missing": "{{field}} مطلوب",
      "pattern": "تنسيق {{field}} غير صالح",
      "invalid_email": "يرجى إدخال عنوان بريد إلكتروني صالح",
      "invalid": "{{field}} غير صالح",
      "fields": {
        "password": "كلمة المرور",
        "confirm_password": "تأكيد كلمة المرور",
        "email": "البريد الإلكتروني",
        "username": "اسم المستخدم",
        "first_name": "الاسم الأول",
        "last_name": "اسم العائلة",
        "designation": "المسمى الوظيفي",
        "dob": "تاريخ الميلاد"
      }
    },
    "role_selection": {
      "title": "اختر دورك",
      "default_description": "اختر نوع الحساب الذي يناسب احتياجاتك",
      "continue_button": "متابعة",
      "signin_text": "لديك حساب بالفعل؟",
      "signin_link": "تسجيل الدخول",
      "role_placeholder": "اختر دورك...",
      "roles": {
        "employee_label": "مستخدم الشركة",
        "private_label": "طالب",
        "professional_label": "محترف",
        "employee_description": "كمستخدم شركة، ستستخدم أدوات الأمان، وتكمل التدريب المطلوب، وتعزز وعيك بالخصوصية والأمان الرقمي.",
        "private_description": "كطالب، ستتحكم في بياناتك الشخصية، وتصل إلى موارد التدريب الفردية، وتعزز وعيك بالخصوصية والأمان الرقمي.",
        "professional_description": "كمحترف، ستحصل على مسارات تدريب متقدمة ومعامل احترافية وموارد تعلم قائمة على الأدوار."
      }
    },
    "step_progress": {
      "label": "الخطوة {{current}}: {{label}}"
    },
    "company_user_registration": {
      "step1": {
        "progress_label": "إعداد الحساب",
        "title": "إنشاء حساب موظف",
        "description": "أدخل عنوان بريدك الإلكتروني الخاص بالشركة للبدء في تسجيل الموظف.",
        "email_label": "البريد الإلكتروني للموظف",
        "email_placeholder": "أدخل البريد الإلكتروني",
        "next_button": "التالي"
      },
      "step2": {
        "title": "تم العثور على الشركة",
        "description": "هل هذه شركتك؟ يرجى تأكيد التفاصيل أدناه.",
        "company_label": "الشركة:",
        "industry_label": "الصناعة:",
        "wrong_company_button": "لا، شركة خاطئة",
        "confirm_button": "نعم، هذه شركتي"
      },
      "step3": {
        "progress_label": "تفاصيل الحساب",
        "title": "أخبرنا عن نفسك",
        "first_name_label": "الاسم الأول",
        "first_name_placeholder": "أدخل الاسم الأول",
        "last_name_label": "اسم العائلة",
        "last_name_placeholder": "أدخل اسم العائلة",
        "username_label": "اسم المستخدم",
        "username_placeholder": "اختر اسم المستخدم",
        "phone_label": "رقم الهاتف",
        "phone_optional": "(اختياري)",
        "phone_placeholder": "مثال: +92xxxxxxxxxx",
        "designation_label": "المسمى الوظيفي",
        "designation_placeholder": "مثال: مهندس برمجيات",
        "password_label": "كلمة المرور",
        "password_placeholder": "أدخل كلمة المرور",
        "confirm_password_label": "تأكيد كلمة المرور",
        "confirm_password_placeholder": "أكد كلمة المرور",
        "phone_error": "يجب أن يبدأ الهاتف بـ + أو 1-9، متبوعًا بـ 1-14 رقمًا (مثال: +92xxxxxxxxxx)",
        "password_error": "كلمات المرور غير متطابقة",
        "next_button": "التالي",
        "back_button": "العودة والتعديل"
      },
      "step4": {
        "progress_label": "تأكيد التفاصيل",
        "title": "تأكيد ملف الموظف الخاص بك",
        "email_label": "البريد الإلكتروني",
        "company_label": "الشركة",
        "name_label": "الاسم",
        "username_label": "اسم المستخدم",
        "phone_label": "رقم الهاتف",
        "designation_label": "المسمى الوظيفي",
        "terms_text": "أوافق على",
        "terms_link": "شروط الخدمة",
        "and_text": "و",
        "privacy_link": "سياسة الخصوصية",
        "submit_button": "تأكيد وإكمال الإعداد",
        "submitting": "جاري الإرسال...",
        "back_button": "العودة والتعديل",
        "error": "فشل التسجيل. يرجى المحاولة مرة أخرى."
      },
      "step5": {
        "title": "شكرا لتسجيلك معنا.",
        "subtitle": "يرجى التحقق من بريدك الإلكتروني",
        "sent_to": "لقد أرسلنا رابط التحقق إلى:",
        "check_inbox": "يرجى التحقق من صندوق الوارد الخاص بك والنقر على الرابط للتحقق من بريدك الإلكتروني.",
        "expires": "ينتهي الرابط خلال 12 ساعة.",
        "login_button": "الانتقال لتسجيل الدخول",
        "resend_text": "لم تتلق البريد الإلكتروني؟",
        "resend_link": "إعادة الإرسال"
      },
      "email_exists": {
        "title": "هذا البريد الإلكتروني مسجل بالفعل",
        "body": "إذا لم تقم بالتحقق بعد، يمكننا إعادة إرسال رابط التحقق.",
        "resend_button": "إعادة إرسال رسالة التحقق",
        "resending": "جارٍ إعادة الإرسال...",
        "login_button": "الانتقال لتسجيل الدخول",
        "resend_toast": "إذا كان هناك حساب لهذا البريد {{email}}، فقد تم إرسال رسالة تحقق.",
        "resend_error": "تعذر إعادة إرسال رسالة التحقق. حاول مرة أخرى."
      },
      "email_verified": {
        "title": "تم التحقق من هذا البريد الإلكتروني بالفعل",
        "body": "حسابك جاهز. يرجى تسجيل الدخول للمتابعة.",
        "login_button": "الانتقال لتسجيل الدخول"
      },
      "common": {
        "signin_text": "لديك حساب بالفعل؟",
        "signin_link": "تسجيل الدخول"
      }
    },
    "professional_registration": {
      "step1": {
        "progress_label": "إعداد الحساب",
        "title": "إنشاء حساب محترف",
        "description": "أدخل بريدك الإلكتروني المهني للبدء.",
        "email_label": "البريد الإلكتروني المهني",
        "email_placeholder": "أدخل بريدك الإلكتروني",
        "next_button": "التالي"
      },
      "step2": {
        "title": "الملف المهني",
        "description": "أكد المسار والتركيز المهنيين.",
        "track_label": "المسار:",
        "focus_label": "التركيز:",
        "track_value": "المسار المهني",
        "focus_value": "عمليات الأمن",
        "wrong_track_button": "لا، اختر مسارا آخر",
        "confirm_button": "متابعة"
      },
      "step3": {
        "progress_label": "تفاصيل الحساب",
        "title": "أخبرنا عن نفسك",
        "first_name_label": "الاسم الأول",
        "first_name_placeholder": "أدخل اسمك الأول",
        "last_name_label": "اسم العائلة",
        "last_name_placeholder": "أدخل اسم عائلتك",
        "username_label": "اسم المستخدم",
        "username_placeholder": "اختر اسم مستخدم",
        "phone_label": "رقم الهاتف",
        "phone_optional": "(اختياري)",
        "phone_placeholder": "مثال: +92xxxxxxxxxx",
        "designation_label": "المسمى الوظيفي",
        "designation_placeholder": "مثال: محلل أمن",
        "password_label": "كلمة المرور",
        "password_placeholder": "أدخل كلمة المرور",
        "confirm_password_label": "تأكيد كلمة المرور",
        "confirm_password_placeholder": "أكد كلمة المرور",
        "phone_error": "يجب أن يبدأ الهاتف بـ + أو 1-9، متبوعًا بـ 1-14 رقمًا (مثال: +92xxxxxxxxxx)",
        "password_error": "كلمات المرور غير متطابقة",
        "next_button": "التالي",
        "back_button": "العودة والتعديل"
      },
      "step4": {
        "progress_label": "تأكيد التفاصيل",
        "title": "تأكيد ملفك المهني",
        "email_label": "البريد الإلكتروني",
        "track_label": "المسار",
        "name_label": "الاسم",
        "username_label": "اسم المستخدم",
        "phone_label": "رقم الهاتف",
        "designation_label": "المسمى الوظيفي",
        "terms_text": "أوافق على",
        "terms_link": "شروط الخدمة",
        "and_text": "و",
        "privacy_link": "سياسة الخصوصية",
        "submit_button": "تأكيد وإكمال الإعداد",
        "submitting": "جاري الإرسال...",
        "back_button": "العودة والتعديل",
        "error": "فشل التسجيل. يرجى المحاولة مرة أخرى."
      },
      "step5": {
        "title": "شكرا لتسجيلك معنا.",
        "subtitle": "يرجى التحقق من بريدك الإلكتروني",
        "sent_to": "لقد أرسلنا رابط التحقق إلى:",
        "check_inbox": "يرجى التحقق من صندوق الوارد الخاص بك والنقر على الرابط للتحقق من بريدك الإلكتروني.",
        "expires": "ينتهي الرابط خلال 12 ساعة.",
        "login_button": "الانتقال لتسجيل الدخول",
        "resend_text": "لم تتلق البريد الإلكتروني؟",
        "resend_link": "إعادة الإرسال"
      },
      "email_exists": {
        "title": "هذا البريد الإلكتروني مسجل بالفعل",
        "body": "إذا لم تقم بالتحقق بعد، يمكننا إعادة إرسال رابط التحقق.",
        "resend_button": "إعادة إرسال رسالة التحقق",
        "resending": "جارٍ إعادة الإرسال...",
        "login_button": "الانتقال لتسجيل الدخول",
        "resend_toast": "إذا كان هناك حساب لهذا البريد {{email}}، فقد تم إرسال رسالة تحقق.",
        "resend_error": "تعذر إعادة إرسال رسالة التحقق. حاول مرة أخرى."
      },
      "common": {
        "signin_text": "لديك حساب بالفعل؟",
        "signin_link": "تسجيل الدخول"
      }
    },
    "student_registration": {
      "step1": {
        "progress_label": "الخطوة 1: إعداد الحساب",
        "progress_count": "1/4",
        "title": "إنشاء حسابك الشخصي",
        "email_label": "عنوان البريد الإلكتروني الشخصي",
        "email_placeholder": "أدخل بريدك الإلكتروني",
        "next_button": "التالي"
      },
      "step2": {
        "progress_label": "الخطوة 2: تفاصيل الحساب",
        "progress_count": "2/4",
        "title": "أخبرنا عن نفسك",
        "first_name_label": "الاسم الأول",
        "first_name_placeholder": "أدخل اسمك الأول",
        "last_name_label": "اسم العائلة",
        "last_name_placeholder": "أدخل اسم عائلتك",
        "username_label": "اسم المستخدم",
        "username_optional": "(اختياري)",
        "username_placeholder": "اختر اسم مستخدم",
        "phone_label": "رقم الهاتف",
        "phone_optional": "(اختياري)",
        "phone_placeholder": "مثال: +92xxxxxxxxxx",
        "dob_label": "تاريخ الميلاد",
        "dob_optional": "(اختياري)",
        "dob_placeholder": "اختر التاريخ",
        "interests_label": "اهتمامات المستخدم",
        "interests_optional": "(اختياري)",
        "interests_placeholder": "اختر الاهتمامات",
        "password_label": "كلمة المرور",
        "password_placeholder": "أدخل كلمة المرور",
        "confirm_password_label": "تأكيد كلمة المرور",
        "confirm_password_placeholder": "أكد كلمة المرور",
        "phone_error": "يجب أن يبدأ الهاتف بـ + أو 1-9، متبوعًا بـ 1-14 رقمًا (مثال: +92xxxxxxxxxx)",
        "password_error": "كلمات المرور غير متطابقة",
        "next_button": "التالي",
        "back_button": "العودة والتعديل"
      },
      "step3": {
        "progress_label": "الخطوة 3: تأكيد التفاصيل",
        "progress_count": "3/4",
        "title": "تأكيد تفاصيلك",
        "email_label": "البريد الإلكتروني",
        "full_name_label": "الاسم الكامل",
        "username_label": "اسم المستخدم",
        "phone_label": "رقم الهاتف",
        "dob_label": "تاريخ الميلاد",
        "interests_label": "اهتمامات المستخدم",
        "terms_text": "أوافق على",
        "terms_link": "شروط الخدمة",
        "and_text": "و",
        "privacy_link": "سياسة الخصوصية",
        "submit_button": "تأكيد وإنشاء الحساب",
        "submitting": "جاري الإرسال...",
        "back_button": "العودة والتعديل",
        "error": "فشل التسجيل. يرجى المحاولة مرة أخرى."
      },
      "step4": {
        "title": "شكرا لتسجيلك معنا.",
        "subtitle": "يرجى التحقق من بريدك الإلكتروني",
        "sent_to": "لقد أرسلنا رابط التحقق إلى:",
        "check_inbox": "يرجى التحقق من صندوق الوارد الخاص بك والنقر على الرابط للتحقق من بريدك الإلكتروني.",
        "expires": "ينتهي الرابط خلال 12 ساعة.",
        "login_button": "الانتقال لتسجيل الدخول",
        "resend_text": "لم تتلق البريد الإلكتروني؟",
        "resend_link": "إعادة الإرسال",
        "resend_toast": "تمت إعادة إرسال رسالة التحقق إلى {{email}}"
      },
      "email_exists": {
        "title": "هذا البريد الإلكتروني مسجل بالفعل",
        "body": "إذا لم تقم بالتحقق بعد، يمكننا إعادة إرسال رابط التحقق.",
        "resend_button": "إعادة إرسال رسالة التحقق",
        "resending": "جارٍ إعادة الإرسال...",
        "login_button": "الانتقال لتسجيل الدخول",
        "resend_toast": "إذا كان هناك حساب لهذا البريد {{email}}، فقد تم إرسال رسالة تحقق.",
        "resend_error": "تعذر إعادة إرسال رسالة التحقق. حاول مرة أخرى."
      },
      "email_verified": {
        "title": "هذا البريد الإلكتروني تم التحقق منه بالفعل",
        "body": "حسابك جاهز. يرجى تسجيل الدخول للمتابعة.",
        "login_button": "الانتقال لتسجيل الدخول"
      },
      "interests": {
        "cybersecurity": "الأمن السيبراني",
        "privacy": "الخصوصية",
        "networking": "الشبكات",
        "development": "التطوير",
        "other": "أخرى"
      },
      "common": {
        "signin_text": "لديك حساب بالفعل؟",
        "signin_link": "تسجيل الدخول"
      }
    }
  },
  "dashboards": {
    "company_user": {
      "eyebrow": "عمليات النطاق المباشرة",
      "greeting": "مرحباً بعودتك.",
      "subtitle": "تابع تقدّم تدريبك وعُقد المختبر النشطة.",
      "status_connected": "متصل",
      "stat_trainings": "التدريبات المسندة",
      "stat_flags": "الأعلام المُلتقطة",
      "stat_hours": "ساعات التدريب",
      "stat_achievements": "الإنجازات",
      "topology_title": "طوبولوجيا الشبكة الفرعية للنطاق",
      "console_title": "تشخيصات وحدة تحكم النطاق",
      "diagnostics_online": "التشخيصات متصلة",
      "clear_terminal": "مسح الطرفية",
      "active_trainings": "التدريبات النشطة",
      "explore_catalog": "استكشاف الكتالوج",
      "skill_index": "مؤشر المهارات السيبرانية",
      "recent_achievements": "الإنجازات الأخيرة"
    }
  },
  "navbar": {
    "brand": "Quantum Omnirange",
    "links": {
      "dashboard": "لوحة التحكم",
      "boxes": "الصناديق",
      "topology": "الطوبولوجيا"
    },
    "search_placeholder": "ابحث...",
    "search_aria": "بحث",
    "user_menu_aria": "قائمة المستخدم",
    "user": {
      "profile": "الملف الشخصي",
      "settings": "الإعدادات",
      "logout": "تسجيل الخروج",
      "default_name": "مستخدم"
    },
    "logging_out": "جاري تسجيل الخروج..."
  },
  "footer": {
    "brand": "Quantum Omnirange",
    "description": "أمّن بنيتك التحتية الرقمية باستخدام التدريب المتقدم على الأمن السيبراني والمراقبة.",
    "sections": {
      "platform": "المنصة",
      "resources": "الموارد",
      "company": "الشركة"
    },
    "platform_links": {
      "dashboard": "لوحة التحكم",
      "boxes": "الصناديق",
      "topology": "الطوبولوجيا"
    },
    "resources_links": {
      "documentation": "التوثيق",
      "api_reference": "مرجع API",
      "support": "الدعم"
    },
    "company_links": {
      "about_us": "من نحن",
      "contact": "اتصل بنا",
      "privacy_policy": "سياسة الخصوصية"
    },
    "bottom": {
      "copyright": "© {{year}} Quantum Omnirange. جميع الحقوق محفوظة.",
      "terms_of_service": "شروط الخدمة",
      "privacy_policy": "سياسة الخصوصية"
    }
  },
  "topology": {
    "builder_title": "منشئ الطوبولوجيا",
    "builder_description": "صمّم واتصل وانشر شبكتك المخصصة لميدان الأمن السيبراني.",
    "ai": {
      "title": "معماري الذكاء الاصطناعي",
      "history": "السجل",
      "placeholder": "صِف أو عدّل الطوبولوجيا...",
      "welcome": "مرحبًا! أنا مساعد الطوبولوجيا بالذكاء الاصطناعي. صِف ما تريد بناءه وسأولّده لك."
    },
    "device_library": {
      "title": "مكتبة الأجهزة",
      "search_placeholder": "ابحث عن الأجهزة..."
    },
    "devices": {
      "other": "أخرى"
    },
    "actions": "الإجراءات",
    "preview_json": "معاينة JSON",
    "import_topology": "استيراد الطوبولوجيا",
    "reset_canvas": "إعادة تعيين اللوحة",
    "sync": {
      "sync_topology": "مزامنة الطوبولوجيا",
      "sync_topology_with_current_ai_session": "مزامنة الطوبولوجيا مع جلسة الذكاء الاصطناعي الحالية",
      "syncing": "جارٍ المزامنة...",
      "synced": "تمت المزامنة!",
      "failed_to_sync": "فشلت مزامنة الطوبولوجيا",
      "failed_to_sync_with_current_ai_session": "فشلت مزامنة الطوبولوجيا مع جلسة الذكاء الاصطناعي الحالية"
    },
    "my_topologies": {
      "my_topologies": "طوبولوجياتي",
      "recent_topologies": "أحدث الطوبولوجيات",
      "no_topologies_yet": "لا توجد طوبولوجيات بعد. أرسل تصميمًا لعرضه هنا.",
      "unnamed": "غير مسمى",
      "no_description": "لا يوجد وصف",
      "columns": {
        "name": "الاسم",
        "title": "العنوان",
        "nodes": "العقد",
        "edges": "الحواف"
      }
    },
    "default_topologies": {
      "default_topologies": "الطوبولوجيات الافتراضية",
      "available_defaults": "الافتراضيات المتاحة",
      "no_default_topologies": "لا توجد طوبولوجيات افتراضية متاحة حاليًا."
    },
    "submit_topology": {
      "name_this_topology": "سمِّ هذه الطوبولوجيا",
      "give_topology_name": "امنح طوبولوجياك اسمًا قبل الإرسال. سيُستخدم هذا الاسم للتعرّف عليها في طوبولوجياتي.",
      "e_g_production_web_tier": "مثال: طبقة الويب للإنتاج",
      "submit": "إرسال الطوبولوجيا"
    }
  }
}
